module.exports = __webpack_public_path__ + "static-m/img/start.9ce6dab9.png";